/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Modal,
  Label, Input, Button, FormFeedback,
  ModalBody, Table,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import moment from 'moment';
import {
  Formik, Field, Form, FieldArray, useFormikContext,
} from 'formik';
import * as Yup from 'yup';

import { t } from 'i18next';
import { post, put, get } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import LocationForm from '../../components/Warehouse/LocationForm';

import { useScanner } from '../../utilities/ScannerContext';

function Warehouse(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const typeOptions = [
    'P', 'R',
  ];

  const zoneOptions = [
    '1', '2',
  ];

  const [adjustModal, setAdjustModal] = useState(false);
  const [scannedLocation, setScannedLocation] = useState(null);
  const [scannedItem, setScannedItem] = useState(null);
  const [scannedItems, setScannedItems] = useState([]);

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [baseShippingSending, setBaseShippingSending] = useState(false);
  const [baseShippingResult, setBaseShippingResult] = useState(null);
  const [isSuperAdmin] = useState(() => {
    try {
      const user = JSON.parse(localStorage.getItem('authUser') || '{}');
      return Array.isArray(user.roles) && user.roles.includes('Super Admin');
    } catch (error) {
      return false;
    }
  });
  const slots = useRef(null);
  const textlabels = useRef(null);
  const startingIndex = useRef(null);
  const count = useRef(null);
  const adjustFormRef = useRef(null);
  const locRef = useRef(null);

  const launchCreate = () => {
    setCreateModalOpen(true);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'F4') {
        setAdjustModal(true);

        setTimeout(() => {
          locRef.current.focus();
        }, 100);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // Delete a location
  const deleteLocation = (location) => {
    try {
      post('/api/warehouse/location/delete', { id: location.id });
      setRefresh(refresh + 1);
    } catch (err) {
      toastr.error(props.t('Could not delete location'));
    }
  };

  const setNeedsRecount = async (location, needsRecount) => {
    try {
      await put(`/api/warehouse/location/${location.id}/recount`, {
        needs_recount: needsRecount,
      });
      setRefresh((current) => current + 1);
    } catch (err) {
      toastr.error(props.t('Could not update recount status'));
    }
  };

  const setFull = async (location, full) => {
    try {
      await put(`/api/warehouse/location/${location.id}/full`, { full });
      setRefresh((current) => current + 1);
    } catch (err) {
      toastr.error(props.t('Could not update full status'));
    }
  };

  // Input format:
  // 'A-B' -> ['A', 'B']
  // 'A' -> ['A']
  // 'A, B, C' -> ['A', 'B', 'C']
  // 'A, B-C' -> ['A', 'B', 'C']
  // 'A, B-C, D-E' -> ['A', 'B', 'C', 'D', 'E']
  // 'A, B-C, D-E, F' -> ['A', 'B', 'C', 'D', 'E', 'F']
  // 'A, B-C, D-E, F-G' -> ['A', 'B', 'C', 'D', 'E', 'F', 'G']
  // 'A1-A30' -> ['A1', 'A2', ..., 'A30']
  const rangeFrom = (str) => {
    if (!str || str.length === 0) return [];
    const items = str.split(',').map((x) => x.trim()).map((x) => x.toUpperCase());
    const result = [];
    items.forEach((item) => {
      if (item.includes('-')) {
        const [start, end] = item.split('-').map((x) => x.trim());
        const isNumeric = start.match(/^\d+$/) && end.match(/^\d+$/);
        // Handle numeric and alpha ranges
        if (isNumeric && start.length > 0 && end.length > 0) {
          // Numeric range
          for (let i = Number(start); i <= Number(end); i += 1) {
            result.push(String(i));
          }
        } else if (start.length === 1 && end.length === 1) {
          // Alpha range
          const startCode = start.charCodeAt(0);
          const endCode = end.charCodeAt(0);
          for (let i = startCode; i <= endCode; i += 1) {
            result.push(String.fromCharCode(i));
          }
        } else if (start.match(/^([A-Za-z]+)(\d+)$/) && end.match(/^([A-Za-z]+)(\d+)$/)) {
          // Mixed range (e.g. A1-A30)
          const startMatch = start.match(/^([A-Za-z]+)(\d+)$/);
          const endMatch = end.match(/^([A-Za-z]+)(\d+)$/);
          if (startMatch && endMatch) {
            const startPrefix = startMatch[1];
            const startNum = parseInt(startMatch[2], 10);
            const endPrefix = endMatch[1];
            const endNum = parseInt(endMatch[2], 10);

            if (startPrefix === endPrefix) {
              for (let i = startNum; i <= endNum; i += 1) {
                result.push(`${startPrefix}${i}`);
              }
            } else {
              result.push(item);
            }
          }
        } else {
          // Fallback: treat as single value if not a valid range
          result.push(item);
        }
      } else {
        result.push(item);
      }
    });
    return result;
  };

  // Generate locations from form data
  // Example input:
  // [
  //   {
  //     segment1: '31,32',
  //     segment2: 'E-G',
  //     segment3: '1',
  //     segment4: 'B',
  //     sequence: 1,
  //     type: 'R',
  //     zone: '1',
  //   },
  // ]
  // Example output:
  // [
  //   { label: '31.E.1.B', sequence: 1, type: 'R', zone: '1' },
  //   { label: '32.E.1.B', sequence: 1, type: 'R', zone: '1' },
  //   { label: '31.F.1.B', sequence: 1, type: 'R', zone: '1' },
  //   { label: '32.F.1.B', sequence: 1, type: 'R', zone: '1' },
  //   { label: '31.G.1.B', sequence: 1, type: 'R', zone: '1' },
  //   { label: '32.G.1.B', sequence: 1, type: 'R', zone: '1' },
  // ]
  const generateLocations = (locations) => {
    const generatedLocations = [];
    locations.forEach((loc) => {
      const segments1 = rangeFrom(loc.segment1);
      const segments2 = rangeFrom(loc.segment2);
      const segments3 = rangeFrom(loc.segment3);
      const segments4 = rangeFrom(loc.segment4);
      const { number, type, zone } = loc;
      let sequence = parseInt(loc.sequence, 10) || 1; // Default to 1 if not a number

      segments1.forEach((seg1) => {
        const segParsed = parseInt(seg1, 10) || 1; // Default to 1 if not a number
        // incr should be 10 if segParsed/2 is even, otherwise -10
        const incr = (segParsed % 2 === 0) ? 10 : -10;

        segments2.forEach((seg2) => {
          segments3.forEach((seg3) => {
            // There may only be 3 segments given.  Short circuit if so.
            if (!segments4 || segments4.length === 0) {
              generatedLocations.push({
                label: `${seg1}.${seg2}.${seg3}`,
                sequence,
                type,
                zone,
              });
            } else {
              segments4.forEach((seg4) => {
                generatedLocations.push({
                  label: `${seg1}.${seg2}.${seg3}.${seg4}`,
                  sequence,
                  type,
                  zone,
                });
                sequence += incr;
              });
            }
          });
        });
      });
    });
    return generatedLocations;
  };

  const loadLocationContents = async (location) => {
    try {
      const contents = await get(`/api/warehouse/location/stock?f=${encodeURIComponent(`pl.label=${location}`)}&per=1000`);

      setScannedItems(contents.results.map((x) => ({
        location_item_id: x.id,
        stock_id: x.stock_id,
        sku: x.kit ? x.kit.sku : x.inventory.part_number,
        qty: x.qty,
      })));
    } catch (error) {
      toastr.error(error.message, 'Error loading location contents');
    }
  };

  const printLocations = async (locations) => {
    await post('/api/warehouse/ops/printLocations', { locations });
  };

  // Print labels for pick carts or slots
  const printLabels = async () => {
    const slotList = slots.current.value.split('\n').map((x) => x.trim()).filter((x) => x);
    if (slotList.length === 0) {
      toastr.error(props.t('Please enter at least one slot number'));
      return;
    }

    await post('/api/warehouse/ops/print', { slots: slotList });
  };

  // Print plaintext labels (no QR code)
  const printTextLabels = async () => {
    const labels = textlabels.current.value.split('\n').map((x) => x.trim()).filter((x) => x);
    if (labels.length === 0) {
      toastr.error(props.t('Please enter at least one line of text'));
      return;
    }

    try {
      await post('/api/warehouse/ops/printPlaintext', { labels });
    } catch (error) {
      toastr.error(props.t('Error printing labels', error.message));
    }
  };

  const printStickers = async () => {
    await post('/api/warehouse/ops/stickers');
  };

  const printLPNs = async () => {
    // Validate that starting index is a number
    if (Number.isNaN(Number(startingIndex.current.value))
      || Number.isNaN(Number(count.current.value))) {
      toastr.error(props.t('Starting index and count must be numbers'));
      return;
    }
    await post('/api/warehouse/ops/lpn', { starting_index: startingIndex.current.value, count: count.current.value });
  };

  const sendBaseShippingNow = async () => {
    setBaseShippingSending(true);
    setBaseShippingResult(null);

    try {
      const result = await post('/api/warehouse/ops/base-shipping/export-all');
      setBaseShippingResult(result);

      if (result.failed > 0) {
        toastr.warning(props.t('BASE rejected one or more shipping records'));
      } else {
        toastr.success(props.t('BASE shipping records sent successfully'));
      }
    } catch (error) {
      const response = error.response?.data;
      setBaseShippingResult({
        error: response?.error || error.message,
        base_status: response?.base_status || error.response?.status || null,
        base_response: response?.base_response || null,
      });
      toastr.error(props.t('Could not send shipping records to BASE'));
    } finally {
      setBaseShippingSending(false);
    }
  };

  const segmentPattern = /^([A-Za-z0-9]+(-[A-Za-z0-9]+)?)(,[A-Za-z0-9]+(-[A-Za-z0-9]+)?)*$/;
  // const optionalSegmentPattern
  //  = /^((?:[A-Za-z0-9]+(?:-[A-Za-z0-9]+)?)(?:,[A-Za-z0-9]+(?:-[A-Za-z0-9]+)?)*)?$/;

  const locationRowSchema = Yup.object().shape({
    segment1: Yup.string()
      .matches(segmentPattern, 'Invalid format')
      .required('Required'),
    segment2: Yup.string()
      .matches(segmentPattern, 'Invalid format')
      .required('Required'),
    segment3: Yup.string()
      .matches(segmentPattern, 'Invalid format')
      .required('Required'),
    // segment4: Yup.string()
    //   .matches(optionalSegmentPattern, 'Invalid format')
    //   .optional(),
    sequence: Yup.number()
      .typeError('Must be a number')
      .integer('Must be an integer')
      .min(100, 'Must be at least 100')
      .required('Required'),
    type: Yup.string()
      .oneOf(typeOptions, 'Invalid type') // adjust as needed
      .required('Required'),
  });

  const ValidationSchema = Yup.object({
    locations: Yup.array().of(locationRowSchema),
  });

  const AdjustValidationSchema = Yup.object({
    location: Yup.string().required(props.t('Must provide a location')),
    items: Yup.array().of(Yup.object().shape({
      location_item_id: Yup.number().nullable(),
      stock_id: Yup.string().required(props.t('Item stock id is required')),
      qty: Yup.number().min(1),
    })),
  });

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="6">
            <Card>
              <CardHeader className="bg-transparent border-bottom">{props.t('Locations')}</CardHeader>
              <CardBody>
                <Can i="see" this="warehouse">
                  <Button color="primary" size="sm" onClick={() => { setAdjustModal(true); }}>Adjust Inventory</Button>
                  <BaseGrid
                    url="/api/warehouse/location"
                    hasSearch
                    create={launchCreate}
                    shouldUpdate={refresh}
                    config={
                      {
                        columns: {
                          id: { label: 'ID', sort: true },
                          zone: { label: 'Zone', sort: true },
                          label: { label: 'Label', sort: true },
                          type: { label: 'Type', sort: true },
                          sequence: { label: 'Sequence', sort: true },
                          needs_recount: {
                            label: 'Recount',
                            sort: false,
                            translate: false,
                            checkbox: {
                              checked: (location) => Boolean(location.needs_recount),
                              change: setNeedsRecount,
                            },
                          },
                          full: {
                            label: 'Full',
                            sort: false,
                            translate: false,
                            checkbox: {
                              checked: (location) => Boolean(location.full),
                              change: setFull,
                            },
                          },
                          actions: {
                            label: 'Actions',
                            actions: [
                              {
                                key: 'delete_location',
                                icon: 'mdi mdi-close-thick',
                                class: 'btn btn-sm btn-soft-danger text-dark',
                                alt: 'Delete',
                                click: deleteLocation,
                              },
                            ],
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'asc',
                          perPage: 10,
                        },
                      }
                    }
                  />
                </Can>

                <Can not i="see" this="warehouse"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>

            <Modal
              size="md"
              isOpen={createModalOpen}
            >
              <div className="modal-header">
                <h5
                  className="modal-title mt-0"
                >
                  {props.t('New Physical Location')}
                </h5>
                <button
                  onClick={() => { setCreateModalOpen(false); }}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <LocationForm
                  onSuccess={() => {
                    setCreateModalOpen(false);
                    setRefresh(refresh + 1);
                  }}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => { setCreateModalOpen(false); }}
                  className="btn btn-soft-dark"
                  data-dismiss="modal"
                >
                  {props.t('Cancel')}
                </button>
                <button
                  type="submit"
                  form="LocationForm"
                  className="btn btn-primary"
                >
                  {props.t('Create')}
                </button>
              </div>
            </Modal>
            <Card>
              <CardHeader className="bg-transparent border-bottom">{props.t('Print Labels')}</CardHeader>
              <CardBody>
                <Can i="see" this="warehouse">
                  <div>
                    <textarea ref={textlabels} className="form-control mb-3" rows="15" placeholder={props.t('Enter newline-separated text')} />
                    <p className="text-muted small">
                      Use
                      {' '}
                      <code>|</code>
                      {' '}
                      to add smaller subtext below the main heading.
                      {' '}
                      Example:
                      {' '}
                      <code>BIN A|Handle with care and keep upright during staging</code>
                    </p>
                    <button type="button" className="btn btn-sm btn-primary" onClick={printTextLabels}>
                      {props.t('Print Text-Only Labels')}
                    </button>
                  </div>
                </Can>
              </CardBody>
            </Card>
          </Col>

          <Col xl="5">
            {isSuperAdmin && (
              <Card className="mb-3">
                <CardHeader className="bg-transparent border-bottom">{props.t('BASE Shipping Export')}</CardHeader>
                <CardBody>
                  <p>{props.t('Send every inventory shipping record with an SJ SKU in batches of 1,000.')}</p>
                  <Button
                    color="primary"
                    size="sm"
                    disabled={baseShippingSending}
                    onClick={sendBaseShippingNow}
                  >
                    {baseShippingSending
                      ? props.t('Sending...')
                      : props.t('Send All Records to BASE')}
                  </Button>

                  {baseShippingResult && !baseShippingResult.error && (
                    <div className="mt-3">
                      <div>{`${props.t('Batches')}: ${baseShippingResult.batches}`}</div>
                      <div>{`${props.t('Requested')}: ${baseShippingResult.requested}`}</div>
                      <div>{`${props.t('Succeeded')}: ${baseShippingResult.succeeded}`}</div>
                      <div>{`${props.t('Failed')}: ${baseShippingResult.failed}`}</div>
                      <div>{`${props.t('Listings updated')}: ${baseShippingResult.listings_updated}`}</div>
                      {baseShippingResult.failure_samples?.length > 0 && (
                        <ul className="mt-2 mb-0">
                          {baseShippingResult.failure_samples.map((failure, index) => (
                            <li key={`${failure.id || 'unknown'}-${index}`}>
                              {`${failure.id || props.t('Unknown item')}: ${failure.message}`}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}

                  {baseShippingResult?.error && (
                    <div className="alert alert-danger mt-3 mb-0">
                      <div>{baseShippingResult.error}</div>
                      {baseShippingResult.base_status && (
                        <div>{`BASE HTTP status: ${baseShippingResult.base_status}`}</div>
                      )}
                      {baseShippingResult.base_response && (
                        <pre className="mt-2 mb-0 text-wrap">
                          {JSON.stringify(baseShippingResult.base_response, null, 2)}
                        </pre>
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            )}

            <Card>
              <CardHeader className="bg-transparent border-bottom">{props.t('Pick Carts')}</CardHeader>
              <CardBody>
                <Can i="see" this="warehouse">
                  <div>
                    <textarea ref={slots} className="form-control mb-3" rows="3" placeholder={props.t('Enter cart/slot numbers')} />
                    <button type="button" className="btn btn-sm btn-primary" onClick={printLabels}>
                      {props.t('Print Cart/Slot Labels')}
                    </button>
                  </div>
                </Can>
              </CardBody>
            </Card>

            <Card className="mt-3">
              <CardHeader className="bg-transparent border-bottom">{props.t('Pick Stickers')}</CardHeader>
              <CardBody>
                <Can i="see" this="warehouse">
                  <div>
                    <p>{props.t('Print 100 stickers for kit item extractions to keep on your cart')}</p>
                    <button type="button" className="btn btn-sm btn-primary" onClick={printStickers}>
                      {props.t('Print 100 Stickers')}
                    </button>
                  </div>
                </Can>
              </CardBody>
            </Card>

            <Card>
              <CardHeader className="bg-transparent border-bottom">{props.t('Print LPNs')}</CardHeader>
              <CardBody>
                <Can i="see" this="warehouse">
                  <div>
                    <input ref={startingIndex} className="form-control mb-3" placeholder={props.t('Starting index')} />
                    <input ref={count} className="form-control mb-3" placeholder={props.t('How many')} />
                    <button type="button" className="btn btn-sm btn-primary" onClick={printLPNs}>
                      {props.t('Print LPNs')}
                    </button>
                  </div>
                </Can>
              </CardBody>
            </Card>

            <Card className="mt-3">
              <CardHeader className="bg-transparent border-bottom">{props.t('Location Generator')}</CardHeader>
              <CardBody>
                <Can i="see" this="warehouse">
                  <p>
                    {props.t('Use this tool to create structured warehouse locations by defining ranges for each of the four segments.')}
                    <br />
                    {props.t('Each row will generate one or more location codes based on the input.')}
                  </p>
                  <h6>{`📦 ${props.t('Segments (1–4)')}`}</h6>

                  <p>
                    {props.t('Each segment defines part of the location code. You can use:')}
                    <br />
                    <ul>
                      <li>Single value: A or 5</li>
                      <li>Range: A-D or 1-10</li>
                      <li>List: A,C,E or 2,4,6</li>
                      <li>Mixed: 1,3-5,7</li>
                    </ul>
                  </p>

                  <p>
                    {props.t('These will be combined to generate location codes like: 10.A.1.A, 11.A.1.A, 12.A.1.A, etc.')}
                  </p>
                  <br />

                  <Formik
                    enableReinitialize
                    initialValues={{
                      locations: [{
                        segment1: '',
                        segment2: '',
                        segment3: '',
                        segment4: '',
                        sequence: '',
                        type: 'P',
                        zone: '1',
                      }],
                    }}
                    validationSchema={ValidationSchema}
                    onSubmit={() => {
                      // Placeholder for form submission logic
                    }}
                  >
                    {({
                      touched, errors, isValid, dirty,
                    }) => (
                      <Form id="LocationGenerator" autoComplete="off">
                        <FieldArray name="locations">
                          {({ push, remove, form }) => (
                            <div>
                              {form.values.locations.map((_, index) => (
                                <>
                                  <Row key={index}>
                                    {['segment1', 'segment2', 'segment3', 'segment4'].map((seg, i) => (
                                      <Col md="3" key={seg}>
                                        <Label>{`Segment ${i + 1}`}</Label>
                                        <Field name={`locations.[${index}].${seg}`}>
                                          {({ field }) => (
                                            <Input
                                              {...field}
                                              bsSize="sm"
                                              invalid={touched?.[index]?.[seg]
                                                && !!errors?.[index]?.[seg]}
                                            />
                                          )}
                                        </Field>
                                        <FormFeedback>
                                          {touched?.[index]?.[seg]
                                            && errors?.[index]?.[seg]}
                                        </FormFeedback>
                                      </Col>
                                    ))}
                                  </Row>
                                  <Row className="mt-2">
                                    <Col md="4">
                                      <Label>{props.t('Pick Sequence')}</Label>
                                      <Field name={`locations.[${index}].sequence`}>
                                        {({ field }) => (
                                          <Input
                                            type="number"
                                            {...field}
                                            bsSize="sm"
                                            invalid={touched?.[index]?.sequence
                                              && !!errors?.[index]?.sequence}
                                          />
                                        )}
                                      </Field>
                                      <FormFeedback>
                                        {touched?.locations?.[index]?.sequence
                                          && errors?.locations?.[index]?.sequence}
                                      </FormFeedback>
                                    </Col>
                                    <Col md="4">
                                      <Label>{props.t('Location Type')}</Label>
                                      <Field name={`locations.[${index}].type`} as="select">
                                        {({ field }) => (
                                          <Input
                                            type="select"
                                            {...field}
                                            bsSize="sm"
                                            invalid={touched?.[index]?.type
                                              && !!errors?.[index]?.type}
                                          >
                                            <option value="">{props.t('Select')}</option>
                                            {typeOptions.map((opt) => (
                                              <option key={opt} value={opt}>
                                                {opt}
                                              </option>
                                            ))}
                                          </Input>
                                        )}
                                      </Field>
                                      <FormFeedback>
                                        {touched?.locations?.[index]?.type
                                          && errors?.locations?.[index]?.type}
                                      </FormFeedback>
                                    </Col>

                                    <Col md="2">
                                      <Label>{props.t('Zone')}</Label>
                                      <Field name={`locations.[${index}].zone`} as="select">
                                        {({ field }) => (
                                          <Input
                                            type="select"
                                            {...field}
                                            bsSize="sm"
                                            invalid={touched?.[index]?.zone
                                              && !!errors?.[index]?.zone}
                                          >
                                            <option value="">{props.t('Select')}</option>
                                            {zoneOptions.map((opt) => (
                                              <option key={opt} value={opt}>
                                                {opt}
                                              </option>
                                            ))}
                                          </Input>
                                        )}
                                      </Field>
                                      <FormFeedback>
                                        {touched?.locations?.[index]?.zone
                                          && errors?.locations?.[index]?.zone}
                                      </FormFeedback>
                                    </Col>
                                    <Col md="2" className="d-flex align-items-end">
                                      <Button color="danger" size="sm" onClick={() => remove(index)}>
                                        <span className="mdi mdi-close-thick" />
                                      </Button>
                                    </Col>
                                  </Row>
                                  <div className="border-bottom mb-4 mt-4" />
                                </>
                              ))}

                              <div className="hstack gap-2 mt-4">
                                <Button
                                  type="button"
                                  size="sm"
                                  color="info"
                                  onClick={() => push({
                                    segment1: '', segment2: '', segment3: '', segment4: '', sequence: '', type: '',
                                  })}
                                >
                                  {props.t('Add Row')}
                                  {' '}
                                  <span className="mdi mdi-plus" />
                                </Button>
                                <Button
                                  type="submit"
                                  size="sm"
                                  color="primary"
                                  onClick={async () => {
                                    const locations = generateLocations(form.values.locations);
                                    await post('/api/warehouse/location/generate', { locations })
                                      .then(() => {
                                        toastr.success(props.t('Locations made successfully'));
                                        setRefresh(refresh + 1);
                                      })
                                      .catch((err) => {
                                        toastr.error(props.t('Error generating locations'));
                                      });

                                    await printLocations(locations);
                                    toastr.success(props.t('Locations printed successfully'));
                                    setRefresh(refresh + 1);
                                  }}
                                  disabled={!(isValid && dirty)}
                                >
                                  <span className="mdi mdi-refresh" />
                                  {' '}
                                  {props.t('Generate and Print')}
                                </Button>
                                <Button
                                  type="submit"
                                  size="sm"
                                  color="primary"
                                  onClick={async () => {
                                    const locations = generateLocations(form.values.locations);
                                    if (locations.length === 0) {
                                      toastr.error(props.t('No locations to print'));
                                      return;
                                    }
                                    await printLocations(locations);
                                    toastr.success(props.t('Locations printed successfully'));
                                    setRefresh(refresh + 1);
                                  }}
                                  disabled={!(isValid && dirty)}
                                >
                                  <span className="mdi mdi-printer" />
                                  {' '}
                                  {props.t('Print Only')}
                                </Button>
                                <Button
                                  type="submit"
                                  size="sm"
                                  color="primary"
                                  onClick={async () => {
                                    const locations = generateLocations(form.values.locations);
                                    if (locations.length === 0) {
                                      toastr.error(props.t('No locations to print'));
                                      return;
                                    }
                                    await post('/api/warehouse/location/generate', { locations })
                                      .then(() => {
                                        toastr.success(props.t('Locations made successfully'));
                                        setRefresh(refresh + 1);
                                      })
                                      .catch((err) => {
                                        toastr.error(props.t('Error generating locations'));
                                      });
                                  }}
                                  disabled={!(isValid && dirty)}
                                >
                                  <span className="mdi mdi-printer" />
                                  {' '}
                                  {props.t('Generate Only')}
                                </Button>
                              </div>
                            </div>
                          )}
                        </FieldArray>
                      </Form>
                    )}
                  </Formik>
                </Can>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="9">
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                {t('Item is Missing')}
              </CardHeader>
              <CardBody>
                <BaseGrid
                  url="/api/warehouse/pick/items"
                  hasSearch
                  shouldUpdate={refresh}
                  filters="void=1&void_reason=Item is missing"
                  config={
                    {
                      columns: {
                        id: {
                          label: 'ID',
                        },
                        pickroute: {
                          label: t('Pickroute'),
                          link: {
                            to: '/warehouse/pickroute/%pickroute_id%',
                          },
                          format: (x) => x.id,
                        },
                        picked_by: {
                          label: 'Reported By',
                        },
                        pickroute_date: {
                          label: ' Pickroute Date',
                          format: (p, x) => moment(x.pickroute.created_at).format('ddd MMM Do h:mma'),
                        },
                        sku: {
                          label: 'Sku',
                          html: true,
                          format: (y, x) => {
                            const sku = x.inventory?.part_number || x.kit?.sku;

                            let html;
                            if (x.inventory) {
                              html = `<a rel="noreferrer" href="/inventory/${x.inventory.id}" target="_blank">${sku}</a>`;
                            } else {
                              html = `<a rel="noreferrer" href="/kits/${x.kit.id}" target="_blank">${sku}</a>`;
                            }

                            return html;
                          },
                        },
                        stock_id: {
                          label: 'Stock ID',
                        },
                        location: {
                          label: 'Location',
                          format: (y) => y && y.label,
                        },
                        qty: {
                          label: 'Qty',
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Formik
          enableReinitialize
          innerRef={adjustFormRef}
          initialValues={{
            location: scannedLocation,
            items: scannedItems,
          }}
          validationSchema={AdjustValidationSchema}
          onSubmit={async (values) => {
            try {
              await put('/api/warehouse/location/stock', values);

              toastr.success('Location stock updated!');
              setAdjustModal(false);
              setScannedLocation(null);
              setScannedItems([]);
            } catch (error) {
              toastr.error(error.message, props.t('Error editing stock'));
            }
          }}
        >
          {({
            touched, errors, values, setFieldValue,
          }) => (
            <Form id="AdjustLocationStockForm" autoComplete="off">
              <UpdateFieldWithState field="location" value={scannedLocation} />
              <Modal isOpen={adjustModal} size="lg">
                <ModalHeader>
                  {t('Adjust inventory')}
                </ModalHeader>
                <ModalBody>
                  <div className="mb-3">
                    <label htmlFor="fld_location">
                      {t('Location')}
                    </label>
                    <Field
                      id="fld_location"
                      name="location"
                      innerRef={locRef}
                      className="form-control"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.target.blur();

                          loadLocationContents(values.location.replace('~', ''));
                          setScannedLocation(values.location.replace('~', ''));
                        }
                      }}
                    />
                  </div>
                  <FieldArray name="items">
                    {({ push, remove, form }) => (
                      <>
                        <Button
                          color="secondary"
                          size="sm"
                          className="mb-3"
                          onClick={() => {
                            push({ stock_id: '', qty: 0, sku: '' });
                          }}
                        >
                          <span className="mdi mdi-plus-thick" />
                        </Button>

                        <Table className="table table-bordered table-striped">
                          <tbody>
                            {values.items && values.items.map((_, index) => (
                              <tr key={index}>
                                <td>
                                  <Field
                                    name={`items[${index}].stock_id`}
                                  />
                                </td>
                                <td>{_.sku}</td>
                                <td>
                                  <Field
                                    name={`items[${index}].qty`}
                                    type="number"
                                    onChange={(e) => {
                                      setFieldValue(
                                        `items[${index}].qty`,
                                        parseInt(e.target.value, 10),
                                      );
                                    }}
                                  />
                                </td>
                                <td>
                                  <Button color="danger" className="btn-outline" size="sm" onClick={() => { remove(index); }}>
                                    <span className="mdi mdi-close-thick" />
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </>
                    )}
                  </FieldArray>
                </ModalBody>

                <ModalFooter>
                  <Button color="light" size="sm" type="button" onClick={() => { setScannedLocation(null); setAdjustModal(false); setScannedItems([]); }}>
                    {props.t('Cancel')}
                  </Button>
                  <Button color="primary" size="sm" type="submit" form="AdjustLocationStockForm">
                    {props.t('Adjust')}
                  </Button>
                </ModalFooter>
              </Modal>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
function UpdateFieldWithState({ field, value }) {
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    // Update form field 'myField' whenever stateVariable changes
    setFieldValue(field, value);
  }, [field, value]);

  return null; // This component does not render anything
}

Warehouse.defaultProps = {
  t: (x) => (x),
};

Warehouse.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Warehouse));
